export const environment = {
  production: true,
  API_URL: "https://stage.api.mygeo.team",
  FORGOT_URL: "https://stage.api.mygeo.team/auth/recovery",
  REGISTRATION_URL: "https://stage.api.mygeo.team/auth/registration",
  REFRESH_TOKEN_TIMER: 1500000,
  SENTRY_DNS: "https://24055279e2a04ed58ab6bda643e4df42@sentry.leadgroup.su/4",
  hmr: false
};
